import React, { Component } from 'react';
import { withSnackbar } from 'notistack';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { Button, DialogContentText, Divider, FormControl, InputLabel, MenuItem, Select, Switch, TextField } from '@material-ui/core';
import moment from 'moment';
import Loader from '../../elements/loader';
import Config from '../../config/index';
const axios = require('axios');
axios.defaults.headers.common['Authorization'] = localStorage.getItem('user_token');

const roles = [
    { value: 'admin', label: 'Admin' },
    { value: 'teacher', label: 'Teacher' },
    { value: 'student', label: 'Student' },
    { value: 'parents', label: 'Parent' },
];
const roleLabel = (value) => {
    const found = roles.find(role => role.value === value);
    return found ? found.label : value;
};
const actions = [
    { value: 'login', label: 'Login' },
    { value: 'two_factor_on', label: '2FA turned on' },
    { value: 'two_factor_off', label: '2FA turned off' },
];
const actionLabel = (value) => {
    const found = actions.find(action => action.value === (value || 'login'));
    return found ? found.label : value;
};

// "Login as" tab of tenant profile - log in to tenant as any user without password / two-factor code
class LoginAs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            role: 'admin',
            search: '',
            page: 0,
            perPage: 20,
            total: 0,
            users: [],
            isLoading: false,
            manualRole: 'admin',
            manualUsername: '',
            confirmUser: null,
            reason: '',
            reasonError: '',
            isSubmitting: false,
            logs: [],
            logRole: '',
            logAction: '',
            logSearch: '',
        };
        this.searchTimer = null;
    }
    componentDidMount() {
        this.loadUsers();
        this.loadLogs();
    }
    componentWillUnmount() {
        clearTimeout(this.searchTimer);
    }
    handleError = (error, message) => {
        if (error.response && error.response.status === 401) {
            localStorage.setItem('logout', true);
            window.location = '/';
            return;
        }
        if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
        }
        this.props.enqueueSnackbar(message, { variant: 'error' });
    }
    loadUsers = () => {
        let self = this;
        this.setState({ isLoading: true });
        const params = { role: this.state.role, search: this.state.search, page: this.state.page + 1, per_page: this.state.perPage };
        axios.get(Config.apiBaseURL + '/tenant/impersonate_users/' + this.props.tenantId, { params: params })
        .then(response => {
            self.setState({ users: response.data.users, total: response.data.total });
        })
        .catch(function (error) {
            self.setState({ users: [], total: 0 });
            self.handleError(error, 'Error! While loading users.');
        })
        .then(function () {
            self.setState({ isLoading: false });
        });
    }
    loadLogs = () => {
        let self = this;
        axios.get(Config.apiBaseURL + '/tenant/impersonate_logs/' + this.props.tenantId)
        .then(response => {
            self.setState({ logs: response.data });
        })
        .catch(function (error) {
            self.handleError(error, 'Error! While loading login history.');
        });
    }
    handleRoleChange = (event) => {
        this.setState({ role: event.target.value, page: 0, search: '' }, this.loadUsers);
    }
    handleSearchChange = (event) => {
        clearTimeout(this.searchTimer);
        this.setState({ search: event.target.value, page: 0 });
        this.searchTimer = setTimeout(this.loadUsers, 400);
    }
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadUsers);
    }
    // twoFactor: null = login as user, true / false = turn user's two-factor authentication on / off
    openConfirm = (role, username, name, twoFactor = null) => {
        if (username.trim() === '') {
            this.props.enqueueSnackbar('Please enter username.', { variant: 'error' });
            return;
        }
        this.setState({ confirmUser: { role: role, username: username.trim(), name: name, twoFactor: twoFactor }, reason: '', reasonError: '' });
    }
    confirmAction = () => {
        if (this.state.confirmUser.twoFactor === null) {
            this.loginAs();
        } else {
            this.changeTwoFactor();
        }
    }
    changeTwoFactor = () => {
        let self = this;
        const reason = this.state.reason.trim();
        if (reason.length < 5) {
            this.setState({ reasonError: 'Please enter a reason (at least 5 characters).' });
            return;
        }
        const user = this.state.confirmUser;
        this.setState({ isSubmitting: true });
        axios.post(Config.apiBaseURL + '/tenant/impersonate_two_factor/' + this.props.tenantId, { role: user.role, username: user.username, enable: user.twoFactor, reason: reason })
        .then(response => {
            self.props.enqueueSnackbar(response.data.message, { variant: 'success' });
            self.setState({
                confirmUser: null,
                users: self.state.users.map(row => (self.state.role === user.role && row.username === user.username) ? Object.assign({}, row, { two_factor: response.data.two_factor, two_factor_default: 0 }) : row),
            });
            self.loadLogs();
        })
        .catch(function (error) {
            self.handleError(error, 'Error! While updating two-factor authentication.');
        })
        .then(function () {
            self.setState({ isSubmitting: false });
        });
    }
    closeConfirm = () => {
        this.setState({ confirmUser: null });
    }
    loginAs = () => {
        let self = this;
        const reason = this.state.reason.trim();
        if (reason.length < 5) {
            this.setState({ reasonError: 'Please enter a reason (at least 5 characters).' });
            return;
        }
        // window must be opened in the click itself, else browser blocks it as popup
        const winName = 'c365_login_' + Date.now();
        const loginWindow = window.open('about:blank', winName);
        if (!loginWindow) {
            this.props.enqueueSnackbar('Please allow popups for this site and try again.', { variant: 'error' });
            return;
        }
        const user = this.state.confirmUser;
        this.setState({ isSubmitting: true });
        axios.post(Config.apiBaseURL + '/tenant/impersonate_login/' + this.props.tenantId, { role: user.role, username: user.username, reason: reason })
        .then(response => {
            // token lives 60 seconds and works once - post it right away, never keep it
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = response.data.actionUrl;
            form.target = winName;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'token';
            input.value = response.data.token;
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
            form.remove();
            self.setState({ confirmUser: null });
            self.loadLogs();
        })
        .catch(function (error) {
            loginWindow.close();
            self.handleError(error, 'Error! While logging in as user.');
        })
        .then(function () {
            self.setState({ isSubmitting: false });
        });
    }
    render() {
        let userRows;
        if (this.state.isLoading) {
            userRows = <TableRow><TableCell colSpan={5}><Loader type='inline' /></TableCell></TableRow>;
        } else if (this.state.users.length === 0) {
            userRows = <TableRow><TableCell colSpan={5}>No users found.</TableCell></TableRow>;
        } else {
            userRows = this.state.users.map(user =>
                <TableRow key={user.id}>
                    <TableCell>
                        {user.name}
                        {user.main_admin === 1 ? <Chip label='Main admin' size='small' className="chipEffect" style={{ marginLeft: 8, backgroundColor: '#3f51b5' }} /> : ''}
                    </TableCell>
                    <TableCell>{user.username}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                        <Switch size='small' color='primary' checked={user.two_factor === 1} onChange={() => this.openConfirm(this.state.role, user.username, user.name, user.two_factor !== 1)} />
                        {user.two_factor === 1 ? 'On' : 'Off'}
                        {user.two_factor_default === 1 ? <span style={{ color: '#888', fontSize: 12 }}> (default)</span> : ''}
                    </TableCell>
                    <TableCell>
                        <Button size='small' variant='outlined' color='primary' onClick={() => this.openConfirm(this.state.role, user.username, user.name)}>Login as</Button>
                    </TableCell>
                </TableRow>
            );
        }

        const logSearch = this.state.logSearch.trim().toLowerCase();
        const logs = this.state.logs.filter(log =>
            (this.state.logRole === '' || log.role === this.state.logRole) &&
            (this.state.logAction === '' || (log.action || 'login') === this.state.logAction) &&
            (logSearch === '' || [log.operator_email, log.username, log.reason].some(value => (value || '').toLowerCase().indexOf(logSearch) !== -1))
        );

        const confirmUser = this.state.confirmUser;
        const isTwoFactorChange = confirmUser !== null && confirmUser.twoFactor !== null;
        let confirmLabel = this.state.isSubmitting ? 'Logging in...' : 'Login';
        if (isTwoFactorChange) {
            confirmLabel = this.state.isSubmitting ? 'Saving...' : (confirmUser.twoFactor ? 'Turn on' : 'Turn off');
        }
        const confirmDialog = <Dialog open={confirmUser !== null} onClose={this.closeConfirm}>
            <DialogTitle>{isTwoFactorChange ? 'Two-factor authentication' : 'Login as user'}</DialogTitle>
            <DialogContent>
                {confirmUser !== null && !isTwoFactorChange ? <DialogContentText>
                    You are about to log in to {this.props.instituteName} as <b>{confirmUser.name || confirmUser.username}</b> ({roleLabel(confirmUser.role)}, username: {confirmUser.username}). This is recorded.
                </DialogContentText> : ''}
                {isTwoFactorChange ? <DialogContentText>
                    You are about to turn <b>{confirmUser.twoFactor ? 'on' : 'off'}</b> two-factor authentication for <b>{confirmUser.name || confirmUser.username}</b> ({roleLabel(confirmUser.role)}, username: {confirmUser.username}) in {this.props.instituteName}.
                    {confirmUser.twoFactor ? ' A verification code will be asked at login.' : ' Trusted browsers of the user are removed too.'} This is recorded.
                </DialogContentText> : ''}
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    margin='normal'
                    variant='outlined'
                    label='Reason (e.g. support ticket number)'
                    value={this.state.reason}
                    onChange={(event) => this.setState({ reason: event.target.value, reasonError: '' })}
                    error={this.state.reasonError !== ''}
                    helperText={this.state.reasonError}
                    inputProps={{ maxLength: 500 }}
                />
            </DialogContent>
            <DialogActions style={{ padding: "24px" }}>
                <Button variant='contained' color='primary' disabled={this.state.isSubmitting} onClick={this.confirmAction}>{confirmLabel}</Button>
                <Button variant='contained' onClick={this.closeConfirm}>Cancel</Button>
            </DialogActions>
        </Dialog>;

        return (
            <div style={{ fontSize: 14 }}>
                <Typography variant='h6'>Users</Typography>
                <Grid container spacing={2} alignItems="center" style={{ marginTop: 5 }}>
                    <Grid item xs={12} sm={3}>
                        <FormControl variant="outlined" fullWidth size="small">
                            <InputLabel>Role</InputLabel>
                            <Select value={this.state.role} onChange={this.handleRoleChange} label="Role">
                                {roles.map(role => <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <TextField fullWidth size="small" variant="outlined" label="Search name / username / email" value={this.state.search} onChange={this.handleSearchChange} />
                    </Grid>
                </Grid>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>2FA Status</TableCell>
                            <TableCell style={{ minWidth: 100 }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>{userRows}</TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[]}
                                count={this.state.total}
                                rowsPerPage={this.state.perPage}
                                page={this.state.page}
                                onPageChange={this.handleChangePage}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>

                <Divider style={{ marginTop: 20, marginBottom: 20 }}></Divider>
                <Typography variant='h6'>Login by username</Typography>
                <Grid container spacing={2} alignItems="center" style={{ marginTop: 5 }}>
                    <Grid item xs={12} sm={3}>
                        <FormControl variant="outlined" fullWidth size="small">
                            <InputLabel>Role</InputLabel>
                            <Select value={this.state.manualRole} onChange={(event) => this.setState({ manualRole: event.target.value })} label="Role">
                                {roles.map(role => <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <TextField fullWidth size="small" variant="outlined" label="Username" value={this.state.manualUsername} onChange={(event) => this.setState({ manualUsername: event.target.value })} />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Button variant='contained' color='primary' onClick={() => this.openConfirm(this.state.manualRole, this.state.manualUsername, '')}>Login as</Button>
                    </Grid>
                </Grid>

                <Divider style={{ marginTop: 20, marginBottom: 20 }}></Divider>
                <Typography variant='h6'>History</Typography>
                <Grid container spacing={2} alignItems="center" style={{ marginTop: 5 }}>
                    <Grid item xs={12} sm={3}>
                        <FormControl variant="outlined" fullWidth size="small">
                            <InputLabel>Role</InputLabel>
                            <Select value={this.state.logRole} onChange={(event) => this.setState({ logRole: event.target.value })} label="Role">
                                <MenuItem value=''>All</MenuItem>
                                {roles.map(role => <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl variant="outlined" fullWidth size="small">
                            <InputLabel>Action</InputLabel>
                            <Select value={this.state.logAction} onChange={(event) => this.setState({ logAction: event.target.value })} label="Action">
                                <MenuItem value=''>All</MenuItem>
                                {actions.map(action => <MenuItem key={action.value} value={action.value}>{action.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <TextField fullWidth size="small" variant="outlined" label="Search by / username / reason" value={this.state.logSearch} onChange={(event) => this.setState({ logSearch: event.target.value })} />
                    </Grid>
                </Grid>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>By</TableCell>
                            <TableCell>Action</TableCell>
                            <TableCell>Role</TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>Reason</TableCell>
                            <TableCell>IP</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {logs.length === 0 ? <TableRow><TableCell colSpan={7}>{this.state.logs.length === 0 ? 'No history yet.' : 'No matching history.'}</TableCell></TableRow> :
                            logs.map(log =>
                                <TableRow key={log.id}>
                                    <TableCell>{moment(log.created).format('DD MMM YYYY hh:mm A')}</TableCell>
                                    <TableCell>{log.operator_email}</TableCell>
                                    <TableCell>{actionLabel(log.action)}</TableCell>
                                    <TableCell>{roleLabel(log.role)}</TableCell>
                                    <TableCell>{log.username}</TableCell>
                                    <TableCell><div className="TableWordBreak">{log.reason}</div></TableCell>
                                    <TableCell>{log.operator_ip}</TableCell>
                                </TableRow>
                            )}
                    </TableBody>
                </Table>
                {confirmDialog}
            </div>
        );
    }
}

export default withSnackbar(LoginAs);
